import { DataSource, Label, Layout, Location, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverQuickInfo extends Layout {
    labelN: Label;
    locationHome: Location;
    panelFullName: Panel;
    panelQuickInfo: Panel;
    sourceDriverInfo: DataSource;
    textboxContactemail: Textbox;
    textboxContactmobilePhone: Textbox;
    textboxContactname: Textbox;
    textboxContactphone: Textbox;
    textboxFirstName: Textbox;
    textboxFleetManagerName: Textbox;
    textboxFullName: Textbox;
    textboxId: Textbox;
}
